'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaEmpire = function FaEmpire(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.5 36.6v1.4q-4.6-0.1-8.6-2.4t-6.3-6.2l1.3-0.7q0.6 1.1 1.6 2.2l1.5-1.3q3.3 3.8 8.2 4.8l-0.4 1.9q1.5 0.2 2.7 0.3z m-13.3-11.9l-1.9 0.7q0.5 1.3 1.1 2.5l-1.3 0.7q-2.2-4-2.2-8.6t2.2-8.6l1.3 0.7q-0.7 1.3-1.1 2.5l1.8 0.7q-0.7 2.2-0.7 4.7 0 2.4 0.8 4.7z m27.9 4l1.3 0.7q-2.4 3.9-6.3 6.2t-8.6 2.4v-1.4q1.2-0.1 2.7-0.3l-0.4-1.9q4.9-1 8.2-4.8l1.5 1.3q1-1.1 1.6-2.2z m-3.4-12.4l-5.2 1.8q0.3 0.9 0.3 1.9t-0.3 1.9l5.2 1.8q-0.7 2-2.2 3.8l-4.1-3.7q-1.3 1.5-3.3 1.9l1.1 5.4q-1.2 0.2-2.2 0.2t-2.2-0.2l1.1-5.4q-2-0.4-3.3-1.9l-4.1 3.7q-1.5-1.8-2.2-3.8l5.2-1.8q-0.3-0.9-0.3-1.9t0.3-1.9l-5.2-1.8q0.7-2.1 2.2-3.8l4.1 3.7q1.3-1.6 3.3-2l-1.1-5.3q1-0.2 2.2-0.2t2.2 0.2l-1.1 5.3q2 0.4 3.3 2l4.1-3.7q1.5 1.7 2.2 3.8z m-11.2-14.3v1.4q-1.4 0.1-2.7 0.3l0.4 1.9q-4.9 1-8.2 4.8l-1.5-1.3q-0.8 0.9-1.6 2.2l-1.3-0.7q2.4-3.9 6.3-6.2t8.6-2.4z m18.6 18q0 4.6-2.2 8.6l-1.3-0.7q0.6-1.2 1.1-2.5l-1.9-0.7q0.8-2.3 0.8-4.7 0-2.5-0.7-4.7l1.8-0.7q-0.4-1.2-1.1-2.5l1.3-0.7q2.2 4 2.2 8.6z m-2.7-9.4l-1.3 0.7q-0.8-1.3-1.6-2.2l-1.5 1.3q-3.3-3.8-8.2-4.8l0.4-1.9q-1.3-0.2-2.7-0.3v-1.4q4.7 0.1 8.6 2.4t6.3 6.2z m3.6 9.4q0-3.9-1.5-7.4t-4-6.1-6.1-4-7.4-1.5-7.4 1.5-6.1 4-4 6.1-1.5 7.4 1.5 7.4 4 6.1 6.1 4 7.4 1.5 7.4-1.5 6.1-4 4-6.1 1.5-7.4z m1 0q0 4.1-1.6 7.8t-4.2 6.4-6.4 4.2-7.8 1.6-7.8-1.6-6.4-4.2-4.2-6.4-1.6-7.8 1.6-7.8 4.2-6.4 6.4-4.2 7.8-1.6 7.8 1.6 6.4 4.2 4.2 6.4 1.6 7.8z' })
        )
    );
};

exports.default = FaEmpire;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/empire.js
// module id = 718
// module chunks = 168707334958949